<template>
  <div id="app" class="l-height-100">
    <Sidebar></Sidebar>
    <router-view></router-view>
    <GoogleAnalytics></GoogleAnalytics>
  </div>
</template>

<script>
import Sidebar from '@/components/Sidebar'
import GoogleAnalytics from '@/components/GoogleAnalytics'

export default {
  name: 'app',
  components: {
    'Sidebar': Sidebar,
    'GoogleAnalytics': GoogleAnalytics
  }
}
</script>

<style lang="scss">
@import "../node_modules/reset-css/reset.css";
@import "./src/sass/settings";
@import "./src/sass/layout";
@import "./src/sass/base";
@import "./src/sass/btn";
@import "./src/sass/icons";
@import "./src/sass/controls";
@import "./src/sass/card";
@import "./src/sass/fetch";
@import "./src/sass/content";
</style>



// WEBPACK FOOTER //
// App.vue?12f33274